import React from "react";
import { InputNumber } from "primereact/inputnumber";
import { Button } from "primereact/button";
import { Tooltip } from "primereact/tooltip";
import localeText from "../../../../../../locale";
import InviteCouponSectionHeading from "./InviteCouponSectionHeading";

const MIN_COUPON = 50;

const InviteCouponStep1 = ({
  extracoinBalance,
  amount,
  onAmountChange,
  submitting,
  formError,
  canSubmit,
  onCancel,
  onSubmit,
  balanceFormatted,
}) => {
  const belowMinBalance = extracoinBalance < MIN_COUPON;

  return (
    <div className="flex flex-column gap-3">
      <div
        className="border-1 border-round-md overflow-hidden"
        style={{ borderColor: "var(--theme-border, #EBEBEB)" }}
      >
        <InviteCouponSectionHeading label={localeText("inviteCouponSectionBalance")} />
        <div className="p-3 bg-white">
          <div className="text-2xl font-bold" style={{ color: "var(--theme-text, #171717)" }}>
            {balanceFormatted} ECR
          </div>
        </div>
      </div>

      <div
        className="border-1 border-round-md overflow-hidden"
        style={{ borderColor: "var(--theme-border, #EBEBEB)" }}
      >
        <InviteCouponSectionHeading label={localeText("inviteCouponSectionData")} />
        <div className="p-3 bg-white flex flex-column gap-2">
          <label
            htmlFor="invite-coupon-amount"
            className="flex align-items-center gap-2 font-medium text-sm"
          >
            {localeText("inviteCouponAmountLabel")}
            <i
              id="invite-coupon-amount-info"
              className="pi pi-info-circle text-xs cursor-pointer"
              style={{ color: "var(--theme-text-muted, #7A869A)" }}
            />
            <Tooltip
              target="#invite-coupon-amount-info"
              content={localeText("inviteCouponAmountTooltip")}
            />
          </label>
          <InputNumber
            id="invite-coupon-amount"
            value={amount}
            onValueChange={(e) => onAmountChange(e.value)}
            mode="decimal"
            minFractionDigits={2}
            maxFractionDigits={2}
            min={belowMinBalance ? 0 : MIN_COUPON}
            max={extracoinBalance}
            suffix=" ECR"
            className="w-full"
            disabled={belowMinBalance || submitting}
            placeholder="0,00"
          />
          <p
            className="text-xs m-0 flex align-items-start gap-2"
            style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
          >
            <i className="pi pi-info-circle mt-1" style={{ fontSize: "0.75rem" }} />
            <span>{localeText("inviteCouponAmountHint", { balance: balanceFormatted })}</span>
          </p>
          {belowMinBalance && (
            <p className="text-sm m-0" style={{ color: "var(--red-500, #dc3545)" }}>
              {localeText("inviteCouponBelowMinBalance", { min: String(MIN_COUPON) })}
            </p>
          )}
        </div>
      </div>

      {formError && (
        <div
          className="text-sm p-2 border-round-md"
          style={{
            background: "color-mix(in srgb, var(--red-500, #dc3545) 12%, transparent)",
            color: "var(--red-600, #b02a37)",
          }}
        >
          {formError}
        </div>
      )}

      {submitting && (
        <div
          className="text-sm p-3 border-round-md flex align-items-center gap-2"
          style={{
            background: "color-mix(in srgb, var(--blue-500, #3b82f6) 12%, transparent)",
            color: "var(--theme-text, #344563)",
          }}
        >
          <i className="pi pi-spin pi-spinner" />
          {localeText("inviteCouponCreating")}
        </div>
      )}

      <div className="flex gap-2 pt-2">
        <Button
          type="button"
          label={localeText("inviteCouponCancel")}
          className="p-button-outlined flex-1 border-round-md p-no-outline"
          style={{ borderColor: "var(--theme-border, #EBEBEB)" }}
          color="var(--theme-text-muted, #5C5C5C)"
          onClick={onCancel}
          disabled={submitting}
        />
        <Button
          type="button"
          label={localeText("inviteCouponCreate")}
          className="flex-1 border-round-md p-no-outline"
          style={{ backgroundColor: "var(--theme-primary, #272360)" }}
          color="var(--theme-primary-text, #ffffff)"
          onClick={onSubmit}
          disabled={!canSubmit || submitting}
        />
      </div>
    </div>
  );
};

export default InviteCouponStep1;
export { MIN_COUPON };
